import React from "react";

import TawkMessengerReact from "@tawk.to/tawk-messenger-react";

import config from "../Config";

export const TawkTo = () => {
	const { TAWK_TO_KEY } = config;

	return (
		<TawkMessengerReact
			propertyId={TAWK_TO_KEY}
			widgetId="default"
		/>
	);
};
